import { CircularProgress } from '@material-ui/core'
import { PropTypes } from 'prop-types'
import React from 'react'

export default function LoadingHook({isSmall}) {
    if(isSmall){
        return(<CircularProgress thickness={4.5} size='1.2rem' style={{ marginRight: '1.5rem' }} />)
    }
    
    return (
        <div className='loadingPad'>
             <CircularProgress /> <h3>Loading..</h3>
        </div>
    )
}
LoadingHook.propTypes = {
    isSmall: PropTypes.bool,
}